import WaykeValuationWeb from './App';

declare global {
  interface Window {
    WaykeValuationWeb: typeof WaykeValuationWeb;
  }
}

const scriptTag = document.querySelector<HTMLScriptElement>('script[src*="wayke-valuation-web"]');
if (scriptTag) {
  const shouldInject = !scriptTag.getAttribute('disablecssinjection');
  if (shouldInject) {
    const src = scriptTag.src.replace('.js', '.css');
    const allreadyInjected = !!document.head.querySelector(`[href="${src}"]`);
    if (!allreadyInjected) {
      const cssFile = document.createElement('link');
      cssFile.rel = 'stylesheet';
      cssFile.href = src;
      document.head.appendChild(cssFile);
    }
  }
}

window.WaykeValuationWeb = WaykeValuationWeb;
